import { combineReducers } from 'redux';
import { createReducer } from 'utils';
import types from './types';

const eateries = createReducer([], {
  [types.SET_EATERIES]: (state, action) => action.payload,
});

const story = createReducer([], {
  [types.SET_STORY]: (state, action) => action.payload,
});

const isSaving = createReducer(false, {
  [types.SET_IS_SAVING]: (state, action) => action.payload,
});

const editedSlug = createReducer({}, {
  [types.SET_EDITED_SLUG]: (state, action) => action.payload,
});

const StoryEditor = combineReducers({
  eateries,
  story,
  isSaving,
  editedSlug
});

export default {
  StoryEditor,
};
